import { useEffect } from 'react';

const CLICK_RESET_DELAY_MS = 150;
const TOOLTIP_HIDE_DELAY_MS = 3000;
const TOOLTIP_MOUSEOUT_DELAY_MS = 100;

const assistantMessages = [
  'Hello! I\'m your AI assistant!',
  'Hover over elements to learn more!',
  'Welcome to the digital cosmos!',
  'Ready to explore? Let\'s go!',
  'I\'m here to help you navigate!',
  'Click me for helpful tips!',
  'Explore the portfolio to learn more!',
  'I can guide you through the site!'
];

const useRobotAssistant = (enabled = true) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const robotAssistant = document.querySelector('#robot-assistant');
    const tooltip = document.querySelector('#tooltip');
    const tooltipText = tooltip?.querySelector('.tooltip-text');

    if (!robotAssistant || !tooltip) {
      return undefined;
    }

    let tooltipTimeoutId;
    let hoverTimeoutId;
    let clickResetTimeoutId;

    const clearTimeoutSafely = (timeoutId) => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };

    const hideTooltip = () => {
      tooltip.classList.remove('show');
    };

    const showTooltip = (message) => {
      clearTimeoutSafely(tooltipTimeoutId);

      if (tooltipText) {
        tooltipText.textContent = message;
      } else {
        tooltip.textContent = message;
      }

      tooltip.classList.add('show');
      tooltipTimeoutId = window.setTimeout(hideTooltip, TOOLTIP_HIDE_DELAY_MS);
    };

    const handleClick = () => {
      clearTimeoutSafely(clickResetTimeoutId);
      robotAssistant.style.transform = 'scale(0.9)';

      clickResetTimeoutId = window.setTimeout(() => {
        robotAssistant.style.transform = 'scale(1)';
      }, CLICK_RESET_DELAY_MS);

      const randomMessage = assistantMessages[Math.floor(Math.random() * assistantMessages.length)];
      showTooltip(randomMessage);
    };

    const handleMouseOver = (event) => {
      const target = event.target.closest('[data-tooltip]');

      if (target?.dataset.tooltip) {
        showTooltip(target.dataset.tooltip);
      }
    };

    const handleMouseOut = (event) => {
      if (!event.target.closest('[data-tooltip]')) {
        return;
      }

      clearTimeoutSafely(hoverTimeoutId);
      hoverTimeoutId = window.setTimeout(() => {
        if (!document.querySelector('[data-tooltip]:hover')) {
          hideTooltip();
        }
      }, TOOLTIP_MOUSEOUT_DELAY_MS);
    };

    robotAssistant.addEventListener('click', handleClick);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);

    return () => {
      robotAssistant.removeEventListener('click', handleClick);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
      clearTimeoutSafely(tooltipTimeoutId);
      clearTimeoutSafely(hoverTimeoutId);
      clearTimeoutSafely(clickResetTimeoutId);
    };
  }, [enabled]);
};

export default useRobotAssistant;
